export default class LocalStorageService {
  static setItem(key: string, data: any) {
    localStorage.setItem(key, JSON.stringify(data));
  }

  static getItem(key: string): any | null {
    const dataRaw = localStorage.getItem(key);

    return dataRaw ? JSON.parse(dataRaw) : null;
  }

  static removeItem(key: string) {
    localStorage.removeItem(key);
  }

  static removeItems(keys: string[]) {
    keys.forEach((key) => localStorage.removeItem(key));
  }

  static clear() {
    localStorage.clear();
  }
}
